<template>
    <div>
        <div class="modal" tabindex="-1" role="dialog" id="muven-region-amount-quantity-sales-filter-modal">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Filtro</h5>
                    </div>

                    <div class="modal-body">
                        <div>
                            <div class="row">
                                <div class="col-12 col-md-6">
                                    <div class="form-group mb-0">
                                        <label>Data inicial</label>
                                        <v-date-picker 
                                            :input-props="{'class': 'form-control'}" 
                                            popover-visibility="focus"
                                            v-model="regionAmountQuantityFilter.date.start" />
                                    </div>
                                </div>

                                <div class="col-12 col-md-6">
                                    <div class="form-group mb-0">
                                        <label>Data final</label>
                                        <v-date-picker 
                                            :input-props="{'class': 'form-control'}" 
                                            popover-visibility="focus"
                                            v-model="regionAmountQuantityFilter.date.end" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button type="button" 
                            class="btn btn-primary"
                            :disabled="loadingFilter"
                            @click="getInfoByFilter(regionAmountQuantityFilter)">
                            Filtrar

                            <fa icon="sync-alt" spin v-show="loadingFilter"/>
                        </button>
                        
                        <button type="button" 
                            class="btn btn-outline-secondary" 
                            @click="clearFilter(regionAmountQuantityFilter)">Restaurar</button>

                        <button type="button" 
                            class="btn btn-outline-secondary" 
                            @click="closeFilterModal(ID_MODAL_FILTER)">Fechar</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="muven-card">
            <div class="muven-card-title">
                <p>
                    Quantidade de pedidos por região

                    <button type="button" 
                        class="btn btn-outline-secondary btn-sm float-right"
                        @click="showFilterModal(ID_MODAL_FILTER)">
                        <fa icon="calendar-alt" />
                    </button>
                </p>

                <p class="muven-card-subtitle">
                    <span>{{regionAmountQuantityFilter.dateSubmitted.start | dateFilter}}</span> até <span>{{regionAmountQuantityFilter.dateSubmitted.end | dateFilter}}</span>
                    <span v-show="regionAmountQuantityFilter.hasChannelList()">
                        <br>
                        <span>Canais: {{regionAmountQuantityFilter.getChannelListDescription()}}</span>
                    </span>
                    <span v-show="regionAmountQuantityFilter.hasStoreList()">
                        <br>
                        <span>Lojas: {{regionAmountQuantityFilter.getStoreListDescription()}}</span>
                    </span>
                </p>
            </div>

            <div>
                <highcharts :options="regionAmountQuantityChartOptions" ref="chart"/>
            </div>
        </div>
    </div>    
</template>

<script>
import modalService from '@/utils/services/ModalService'
import dashboardService from '@/dashboard/services/DashboardService'
import {DashboardAverageTicketFilterModel} from '@/dashboard/models/DashboardAverageTicketFilterModel'
import { dateFilter } from '@/utils/filters/DateTimeFilter'
import dashboardFilterMixin from '@/dashboard/mixins/DashboardFilterMixin'
import { DashboardAverageTicketModel } from '@/dashboard/models/DashboardAverageTicketModel'
import {createTreeMapGraphic} from '@/utils/normalizers/GraphicNormalizer'
import {format} from 'date-fns'
import {meanBy, round} from 'lodash'
import { averageColor } from '@/dashboard/constants/Color'
import { adjustsDate } from '@/utils/normalizers/DateNormalizer'
import Highcharts from 'highcharts'

const ID_MODAL_FILTER = '#muven-region-amount-quantity-sales-filter-modal'

export default {
    name: 'RegionAmountQuantitySalesCmp',
    mixins: [
        dashboardFilterMixin,
    ],
    data() {
        return {
            ID_MODAL_FILTER,
            loadingFilter: false,
            regionAmountQuantityFilter: new DashboardAverageTicketFilterModel(),
            regionAmountQuantityList: [],
            regionAmountQuantityChartOptions: createTreeMapGraphic(),  
        }
    },
    filters: {
        dateFilter,
    },
    methods: {
        async getInfoByFilter(filter) {
            this.loadingFilter = true

            filter.fillDateWhenEmpty()
            filter.updatesFilterSubmitted()

            await this.drawGraphic(filter) 
        
            this.loadingFilter = false
            this.closeFilterModal(this.ID_MODAL_FILTER)
        },
        async drawGraphic(filter) {
            this.regionAmountQuantityFilter.updatesFilterSubmittedWith(filter)
            this.regionAmountQuantityList = await dashboardService.getRegionAmountQuantitySales(filter)

            let colorCount = 0

            const series = this.regionAmountQuantityList.map((a, index) => {
                const r = {
                    id: String(a.id),
                    parent: a.idParent ? String(a.idParent) : undefined,
                    name: a.name,
                    value: round(a.value || 0, 2),
                    color: a.idParent ? undefined : Highcharts.getOptions().colors[colorCount],
                }

                if (!a.idParent && !!a.value) {
                    colorCount = colorCount + 1
                }

                return r;
            })

            this.$refs.chart.chart.series[0].setData(series)
        }
    },
    async mounted() {
        await this.drawGraphic(this.regionAmountQuantityFilter)
    },
}
</script>

